// extracted by mini-css-extract-plugin
export default {"container":"DispositionTable_container__Xs9C4"};